// import { useEffect, useState } from "react";
// import QRCode from "qrcode";
// import { lngDetect } from "../../../../helpers/lngDetect";

// const QrTicketDetails = ({ ticket = {} }) => {
//   const [qrCodeUrl, setQrCodeUrl] = useState("");

//   useEffect(() => {
//     const generateQR = async (data) => {
//       try {
//         const qr_data = {
//           ...data?.attendeeInfo,
//           "order id": data?.orderId,
//           "ticket id": data?.ticketInfo?.uid,
//           "event id": data?.ticketInfo?.eventId,
//           name: lngDetect(data?.ticketInfo?.name),
//         };

//         const ticketInfo = Object?.keys(qr_data)
//           ?.map((key) => `${key}: ${qr_data[key]}`)
//           ?.join("\n");

//         let text = `${ticketInfo}`;
//         const url = await QRCode.toDataURL(text);
//         setQrCodeUrl(url);
//       } catch (err) {
//         console.error("QR generation failed:", err);
//       }
//     };

//     generateQR(ticket);
//   }, [JSON.stringify(ticket)]);

//   return (
//     <div>
//       {qrCodeUrl ? (
//         <img src={qrCodeUrl} alt="QR Code" />
//       ) : (
//         <p>Generating QR code...</p>
//       )}
//     </div>
//   );
// };

// export default QrTicketDetails;

import { useEffect, useRef } from "react";
import { lngDetect } from "../../../../helpers/lngDetect";
import QRCodeStyling from "qr-code-styling";
import icon from "../../../../assets/images/no-data-found.png";

const option = (data) => ({
  type: "canvas",
  width: 150,
  height: 150,
  data,
  margin: 0,
  qrOptions: {
    typeNumber: "0",
    mode: "Byte",
    errorCorrectionLevel: "Q",
  },
  imageOptions: {
    saveAsBlob: true,
    hideBackgroundDots: true,
    imageSize: 0.25, // Reduce logo size relative to canvas
    margin: 0,
  },
  dotsOptions: {
    // type: "extra-rounded",
    type: "dots",
    color: "#6a1a4c",
    roundSize: true,
  },
  backgroundOptions: { round: 0, color: "#ffffff" },
  image: icon,
  cornersSquareOptions: { type: "extra-rounded", color: "#000000" },
  cornersDotOptions: { type: "", color: "#000000" },
});

const QrTicketDetails = ({ ticket = {} }) => {
  const qrRef = useRef(null);
  const qrCode = useRef(null);

  useEffect(() => {
    if (!ticket?.ticketInfo) return;

    const attendee_info = {
    ...Object.assign(
      ...ticket?.attendeeData?.map((item) => ({
        [item?.question]: item?.answers,
      })),
      {}
    ),
  };

    const generateQR = async () => {
      try {
        const qr_data = {
          name: `${attendee_info?.["First Name"]} ${attendee_info?.["Last Name"]} (${attendee_info?.["Email"]})`,
          "order id": ticket?.orderId,
          "event id": ticket?.eventId,
          "ticket id": ticket?.ticketInfo?.uid,
          "ticket uid": ticket?.uid,
          ticket: lngDetect(ticket?.ticketInfo?.name),
        };

        const ticketInfo = Object.keys(qr_data)
          .map((key) => `${key}: ${qr_data[key]}`)
          .join("\n");

        qrCode.current = new QRCodeStyling(option(ticketInfo));
        qrRef.current.innerHTML = "";
        qrCode.current.append(qrRef.current);
      } catch (err) {
        console.error("QR generation failed:", err);
      }
    };

    generateQR();
  }, [ticket]);

  return (
    <div className="w-36 aspect-square rounded-xl bg-white/50 backdrop-blur-sm ring-1 ring-slate-200 overflow-hidden flex items-center justify-center">
      <div ref={qrRef} />
    </div>
  );
};

export default QrTicketDetails;
